import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import MenuCliente from './pages/MenuCliente';
import Cameriere from './pages/Cameriere';
import Cucina from './pages/Cucina';
import Cassa from './pages/Cassa';
import Backoffice from './pages/Backoffice';
import Statistiche from './pages/Statistiche';
import ConnectionDebug from './components/ConnectionDebug';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <ConnectionDebug />
        <Navbar />
        <main className="flex-1">
          <AnimatePresence mode="wait">
            <Routes>
              {/* ── Routes PUBBLICI ── accessibili a tutti (clienti, tavoli) */}
              <Route path="/" element={<MenuCliente />} />
              <Route path="/menu" element={<MenuCliente />} />

              {/* ── Routes PROTETTI ── richiedono la password del personale */}
              {/* ProtectedRoute controlla sessionStorage → se non auth mostra modal */}
              <Route path="/cameriere" element={
                <ProtectedRoute><Cameriere /></ProtectedRoute>
              } />
              <Route path="/cucina" element={
                <ProtectedRoute><Cucina /></ProtectedRoute>
              } />
              <Route path="/cassa" element={
                <ProtectedRoute><Cassa /></ProtectedRoute>
              } />
              <Route path="/backoffice" element={
                <ProtectedRoute><Backoffice /></ProtectedRoute>
              } />
              <Route path="/statistiche" element={
                <ProtectedRoute><Statistiche /></ProtectedRoute>
              } />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;